import { Link } from 'react-router-dom';

export default function LandingFooter() {
  return (
    <footer className="border-t border-[#141414]/10 mt-24">
      <div className="max-w-6xl mx-auto px-6 h-20 flex items-center justify-between text-sm text-[#8A8578]">
        <span className="font-extrabold tracking-tight text-[#141414]">Takarah</span>
        <div className="flex items-center gap-6">
          <Link to="/login" className="hover:text-[#141414] transition-colors">
            Entrar
          </Link>
          <span>© {new Date().getFullYear()}</span>
        </div>
      </div>
    </footer>
  );
}
